'use client'

import { Image } from '@/eshop/gql/graphql'
import clsx from 'clsx'
import { useMemo, useState } from 'react'

interface Props {
    images: Image[]
    productName: string
}

export default function ProductDetailImages({ images, productName }: Props) {
    const [selectedIndex, setSelectedIndex] = useState(0)

    const selectedImage = useMemo(() => {
        if (!images || images.length === 0) {
            return '/product.png'
        }
        return (
            (process.env.NEXT_PUBLIC_ESHOP_S3 || '') + images[selectedIndex].url
        )
    }, [images, selectedIndex])

    return (
        <>
            <img
                src={selectedImage}
                className="w-full max-w-md lg:w-auto aspect-auto"
                alt={productName}
            />
            <div className="flex gap-4 mt-4">
                {images.map((image, i) => (
                    <img
                        className={clsx(
                            'w-20 rounded',
                            selectedIndex !== i && 'cursor-pointer'
                        )}
                        alt={productName + ` ${i + 1}`}
                        key={image?.url}
                        onClick={() => setSelectedIndex(i)}
                        src={
                            (process.env.NEXT_PUBLIC_ESHOP_S3 || '') + image.url
                        }
                    />
                ))}
            </div>
        </>
    )
}
